import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "survey-item mt-4 fade-in"
}
const _hoisted_2 = { class: "p-4 has-text-centered is-size-4" }
const _hoisted_3 = { class: "is-flex is-justify-content-center" }
const _hoisted_4 = { class: "p-4 has-text-left is-size-5 survey-subtitle" }
const _hoisted_5 = { class: "p-4 survey-subtitle" }
const _hoisted_6 = { class: "buttons" }
const _hoisted_7 = { class: "buttons" }
const _hoisted_8 = { class: "buttons" }
const _hoisted_9 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isVisible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.titleWord), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.subtitleWord), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", _hoisted_6, [
            _createElementVNode("button", {
              class: "button is-info is-fullwidth",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.routerExternalLink('EDGE')))
            }, _toDisplayString(_ctx.toEdge), 1)
          ]),
          _createElementVNode("p", _hoisted_7, [
            _createElementVNode("button", {
              class: "button is-info is-fullwidth",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.routerExternalLink('DYSLEXIA_RESERCH')))
            }, _toDisplayString(_ctx.toDyslexiaReserchWordB), 1)
          ]),
          _createElementVNode("p", _hoisted_8, [
            _createElementVNode("button", {
              class: "button is-info is-fullwidth",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.routerExternalLink('CONTACT_US')))
            }, _toDisplayString(_ctx.toContactUsWordA), 1)
          ]),
          _createElementVNode("p", _hoisted_9, [
            _createElementVNode("button", {
              class: "button is-light is-fullwidth",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/')))
            }, _toDisplayString(_ctx.buttonWordC), 1)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}